import { useQuery } from '@tanstack/react-query';
import deliveryProvidersService from 'v2/services/delivery-providers';

export const useDeliveryProvider = (newProduct?: boolean) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['deliveryProvider'],
    queryFn: async () => {
      const result = await deliveryProvidersService.list(newProduct);
      return result;
    }
  });

  return {
    data,
    isLoading,
    error
  };
};
